var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 15.8333C6.43056 15.8333 6.23264 15.7535 6.07292 15.5938C5.91319 15.434 5.83333 15.2361 5.83333 15C5.83333 14.7639 5.91319 14.566 6.07292 14.4062C6.23264 14.2465 6.43056 14.1667 6.66667 14.1667H11.75C12.625 14.1667 13.3854 13.8889 14.0312 13.3333C14.6771 12.7778 15 12.0833 15 11.25C15 10.4167 14.6771 9.72222 14.0312 9.16667C13.3854 8.61111 12.625 8.33333 11.75 8.33333H6.5L8.08333 9.91667C8.23611 10.0694 8.3125 10.2639 8.3125 10.5C8.3125 10.7361 8.23611 10.9306 8.08333 11.0833C7.93056 11.2361 7.73611 11.3125 7.5 11.3125C7.26389 11.3125 7.06944 11.2361 6.91667 11.0833L3.91667 8.08333C3.83333 8 3.77431 7.90972 3.73958 7.8125C3.70486 7.71528 3.6875 7.61111 3.6875 7.5C3.6875 7.38889 3.70486 7.28472 3.73958 7.1875C3.77431 7.09028 3.83333 7 3.91667 6.91667L6.91667 3.91667C7.06944 3.76389 7.26389 3.6875 7.5 3.6875C7.73611 3.6875 7.93056 3.76389 8.08333 3.91667C8.23611 4.06944 8.3125 4.26389 8.3125 4.5C8.3125 4.73611 8.23611 4.93056 8.08333 5.08333L6.5 6.66667H11.75C13.0972 6.66667 14.2535 7.10417 15.2188 7.97917C16.184 8.85417 16.6667 9.94444 16.6667 11.25C16.6667 12.5556 16.184 13.6458 15.2188 14.5208C14.2535 15.3958 13.0972 15.8333 11.75 15.8333H6.66667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.a908f0d8f917f670f94a097c8e801801.svg";
export { ForwardRef as ReactComponent };